import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../layouts/full/shared/loadable/Loadable";
import { RouterName } from "./RouterName";
import { dataLocalStorage, getLocalStorage } from "src/helper/publicFunction";

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import("../layouts/full/FullLayout")));
const BlankLayout = Loadable(
  lazy(() => import("../layouts/blank/BlankLayout"))
);

/* ****Pages***** */
const Faqs = Loadable(lazy(() => import("src/pages/faqs/view")));
const Services = Loadable(lazy(() => import("src/pages/services/view")));
const ServicesImage = Loadable(lazy(() => import("src/pages/services_image/view")));
const Features = Loadable(lazy(() => import("src/pages/features/view")));
const Slideshow = Loadable(lazy(() => import("src/pages/slideshow/view")));
const Settings = Loadable(lazy(() => import("src/pages/settings/view")));
const LegalInformation = Loadable(
  lazy(() => import("src/pages/settings/legal_information"))
);
const Logs = Loadable(lazy(() => import("src/pages/admins_logs/view")));
const Contact_info = Loadable(lazy(() => import("src/pages/contact_info/view")));

const HowItWork = Loadable(lazy(() => import("src/pages/how_it_work/view")));

// authentication
const Login = Loadable(
  lazy(() => import("../views/authentication/auth/Login"))
);

const ForgotPassword = Loadable(
  lazy(() => import("../views/authentication/auth/ForgotPassword"))
);
const ResetPassword = Loadable(
  lazy(() => import("src/views/authentication/auth/ResetPassword"))
);

const Error = Loadable(lazy(() => import("../views/authentication/Error")));
const Maintenance = Loadable(
  lazy(() => import("../views/authentication/Maintenance"))
);

const AdminsPage = Loadable(lazy(() => import("../pages/admins/admins/view")));
const PrivilegesPage = Loadable(
  lazy(() => import("../pages/admins/privileges/view"))
);

let data = getLocalStorage(dataLocalStorage.privileges);

const Router = [
  {
    path: "/",
    element: <FullLayout />,
    children: [
      {
        path: "/",
        exact: true,
        element: (
          <Navigate
            to={
              data["6"]?.access_read == 1
              ? RouterName.how_it_work.how_it_work
              : data["13"]?.access_read == 1
              ? RouterName.admins.admins
              : data["3"]?.access_read == 1
              ? RouterName.settings.settings
              : data["10"]?.access_read == 1
              ? RouterName.faqs.faqs
              : data["12"]?.access_read == 1
              ? RouterName.features.features    
              : data["14"]?.access_read == 1
              ? RouterName.slideshow.slideshow    
              : data["15"]?.access_read == 1
              ? RouterName.contact_info.contact_info    
              : data["4"]?.access_read == 1
              ? RouterName.services.services    
              : data["5"]?.access_read == 1
              ? RouterName.services_image.services_image    
              : data["5"]?.access_read == 1
            
            }
          />
        ),
      },

      {
        path: RouterName.admins.admins,
        exact: true,
        element: <AdminsPage />,
      },

      data["1"]?.access_read == 1 && {
        path: RouterName.admins.privileges,
        exact: true,
        element: <PrivilegesPage />,
      },


      data["5"]?.access_read == 1 && {
        path: RouterName.settings.settings,
        exact: true,
        element: <Settings />,
      },
      data["5"]?.access_read == 1 && {
        path: RouterName.legal_information.legal_information,
        exact: true,
        element: <LegalInformation />,
      },
      data["6"]?.access_read == 1 && {
        path: RouterName.how_it_work.how_it_work,
        exact: true,
        element: <HowItWork />,
      },

      {
        path: RouterName.slideshow.slideshow,
        exact: true,
        element: <Slideshow />,
      },
      
      {
        path: RouterName.features.features,
        exact: true,
        element: <Features />,
      },

      {
        path: RouterName.faqs.faqs,
        exact: true,
        element: <Faqs />,
      },

      {
        path: RouterName.services.services,
        exact: true,
        element: <Services />,
      },
      {
        path: RouterName.services_image.services_image,
        exact: true,
        element: <ServicesImage />,
      },

      {
        path: RouterName.contact_info.contact_info,
        exact: true,
        element: <Contact_info />,
      },

      {
        path: RouterName.admins_logs.admins_logs,
        exact: true,
        element: <Logs />,
      },

     

    
    ],
    
  },
  {
    path: "/",
    element: <BlankLayout />,
    children: [
      { path: "/auth/404", element: <Error /> },
      { path: RouterName.auth.login, element: <Login /> },
      { path: RouterName.auth.forgotPassword, element: <ForgotPassword /> },
      { path: RouterName.auth.resetPassword, element: <ResetPassword /> },
      { path: RouterName.auth.maintenance, element: <Maintenance /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
]

export default Router;
